import React, { useState } from "react";
import { Box, useTheme, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BaseCard from "../../../components/Cards/Card";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import profiledone from "../../../assets/profiledone.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import verifyface from "../../../assets/verifyface.png";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { BASE_URL } from "../../../components/BaseUrl";
import { getProfileDraft, clearProfileDraft } from "./ProfileDraft";
const RegisterationVerification = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const navigate = useNavigate();
  const { t } = useTranslation();
  const profileToken =
    useSelector((s) => s.auth.profileUpdateToken) ||
    localStorage.getItem("profileUpdateToken");
console.log(profileToken)
  const [loading, setLoading] = useState(false);
const [isContinueClicked, setIsContinueClicked] = useState(false);
  const handleContinue = async () => {
    const draft = getProfileDraft();
    console.log("📦 Profile Draft (final payload):", draft);
setIsContinueClicked(true);
    if (!profileToken) {
      toast.error("Missing profile token");
      return;
    }
console.log("🔑 profileToken from Redux/localStorage:", profileToken);
console.log("📦 Draft before sending:", draft);
    console.log("🔎 draft.company_id:", draft?.company_id, "draft.department_id:", draft?.department_id);
    const payload = {
     profile_token: profileToken,
      ...draft,
    };

    console.log("📤 Final API Payload:", payload);
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/public/register-worker`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("📩 Register Worker API Response:", data);

      if (!response.ok || data.error) {
        throw new Error(data.message || "Failed to complete registration");
      }

      toast.success(data.message || "Profile created successfully!", {
        id: "verification-success",
      });

      clearProfileDraft(); // cleanup draft storage

      setTimeout(() => {
        navigate("/admin-approval");
      }, 1500);
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ py: isMobile ? 5 : 8, px: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
          alignItems: "center",
        }}
      >
        <BaseCard
          maxWidth={isMobile ? "100%" : isTablet ? "60%" : isLaptop ? "40%" : "30%"}
        >
          <CustomText
            sx={{
              ...textStyles.h4,
              color: "#172B4D",
              textAlign: "center",
              fontSize: "26px",
              letterSpacing: "0px !important",
            }}
          >
            {t("verificationCompleteTitle")}
          </CustomText>
          <CustomText
            sx={{
              ...textStyles.body5,
              color: "#6B778C",
              pt: 1.2,
              textAlign: "center",
              letterSpacing: "0px !important",
            }}
          >
            {t("verificationCompleteSubtitle")}
          </CustomText>

          <Box
            sx={{
              mt: 4,
              px: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <img
              src={verifyface}
              style={{ width: "80%", height: "80%", objectFit: "contain" }}
              alt="verify"
            /> */}
            {getProfileDraft()?.face_image_url && (
  <img
    crossOrigin="anonymous"
    src={getProfileDraft().face_image_url}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
      borderRadius: 8,
    }}
    alt="Captured Face"
  />
)}
              {/* {getProfileDraft()?.face_image_url ? (
    <img
      crossOrigin="anonymous"
      src={getProfileDraft().face_image_url}
      style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 8 }}
      alt="Captured Face"
    />
  ) : (
    <img
      crossOrigin="anonymous"
     src={getProfileDraft().face_image_url} // fallback if no face captured yet
      style={{ width: "80%", height: "80%", objectFit: "contain" }}
      alt="verify"
    />
  )} */}
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <CustomButton
              label={t("back")}
              variant="text"
              onClick={() => navigate(-1)}
              sx={{
            
                px: 0,
       
                height: 20,
        backgroundColor: isContinueClicked ? "#f0f0f0" : "white", // light grey if disabled
    color: isContinueClicked ? "#999" : "black",
    "&:hover": {
      backgroundColor: isContinueClicked ? "#f0f0f0" : "white",
      color: isContinueClicked ? "#999" : "black",
    },
              }}
            />
            <CustomButton
              label={
                loading ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={18} sx={{ color: "#fff" }} />
                    {t("loading")}
                  </Box>
                ) : (
                  t("continue")
                )
              }
              size="medium"
              onClick={handleContinue}
              sx={{ px: 4, height: 20 }}
              disabled={loading}
            />
          </Box>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default RegisterationVerification;


